module.exports = __webpack_public_path__ + "media/assets/invitation-rate-limit-a39a3938b05cfc49b98f57b4e2654170.svg";